import * as orderDetail from '../services/orderDetail';

export default {
  namespace: 'orderDetail',

  state: {
    orderData: {},
  },

  effects: {
    *getOrderDetail({ payload: { values } }, { call, put }) {
      const response = yield call(orderDetail.getOrderDetail, values);
      console.log('response', response);
      yield put({
        type: 'save',
        payload: {
          orderData: response?.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
